import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core'
import { QuoteCheckoutViewModel } from '../../model/quote-checkout-view-model'
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms'
import { QuoteCheckoutService } from '../../services/quote-checkout.service'
import { QuoteDataService } from '../../services/quote-data.service'
import {
  AuthService,
  User,
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import { switchMap, take } from 'rxjs/operators'
import { of, Observable, Subscription } from 'rxjs'
import { QuoteCartService } from '../../../quote-services/quote-cart.service'
import { Router } from '@angular/router'
import { Cart } from '../../model/cart-model'
import {
  BillToAddress,
  DeliveryAddress,
  EndUserAddress,
} from '../../model/address-models'
import { NgSelectComponent } from '@ng-select/ng-select'
import { LaunchDialogService } from '@spartacus/storefront'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { BreadcrumbService } from '../../../../../shared/components/breadcrumb/breadcrumb.service'
import { SpinnerOverlayService } from '../../../../../shared/components/spinner-overlay/spinner-overlay.service'
import { BulkServiceService } from '../../../../bulk-order/bulk-service.service'
import {
  OrderType,
  QuoteStatus,
} from '../../../../../models/status/status.model'
import { VS_LAUNCH_CALLER } from '../../../../config/dialog.config'
//import { CommonService } from '../../../../../shared/services/common.service'

@Component({
  standalone: false,
  selector: 'vs-quote-checkout',
  templateUrl: './quote-checkout.component.html',
  styleUrls: ['./quote-checkout.component.scss'],
})
export class QuoteCheckoutComponent implements OnInit {
  @ViewChild('orderTypeFocus') orderTypeFocus: NgSelectComponent
  vm: QuoteCheckoutViewModel = null
  isLoggedinUser = false
  orderGroup: FormGroup
  orderType: any
  checkoutData: any
  public cartId
  public cartStatus
  public userType
  user$: Observable<User>
  loggedIn: boolean
  cartLoaded = false
  cartData: Cart
  cartData$: Observable<any>
  checkoutCartData: any
  checkoutCartData$: Observable<any>
  userAddressData: any
  userAddressData$: Observable<any>
  productData: any
  orderTypeData: any
  orderTypeData$: Observable<any>
  token: any
  warningDialog
  soldToAddress: {
    firstName: any
    lastName: any
    companyName: any
    line1: any
    line2: any
    region: any
    country: any
    postalCode: any
  }
  submitGuestCheckoutData: any
  questCheckOutFormData: {
    shippingDeatils: any
    soldToAddressDetails: any
    endCustomerDetails: any
    complianceQuestionDetails: any
  }
  cartCode: any
  submitLoginCheckoutData: any
  loggedInShipToAdrress: any
  loggedInEndAdrress: any
  endUserIndustry: any
  orderTypes: any
  notificationEmail: any
  contactNumber: any
  isSubmitted: boolean
  attachmentFiles: any
  billToValidation: boolean
  deliveryValidation: boolean
  endUserValidation: boolean
  complienceValidation: boolean
  notificationValidation: boolean
  rfqTypes: any
  orderChanged: boolean
  progress: number
  isDisabled = false
  count = 1
  public showPrice = true
  validationGroup: string
  endUserIndustries = []
  isUploaded = true
  filesCount = 0
  quoteCheckoutIdGenrate: Subscription
  checkboxFlag: any = ''
  QuoteStatus = QuoteStatus
  //userDetails$: Observable<any>
  //userSapBlocked: boolean = false

  constructor(
    private launchDialogService: LaunchDialogService,
    private fb: FormBuilder,
    private quoteDataService: QuoteDataService,
    private quoteCheckoutService: QuoteCheckoutService,
    private quoteService: QuoteCartService,
    private auth: AuthService,
    //private commonService: CommonService,
    private router: Router,
    private breadCrumbService: BreadcrumbService,
    private globalMessageService: GlobalMessageService,
    private spinnerOverlayService: SpinnerOverlayService,
    private translate: TranslationService,
    private cd: ChangeDetectorRef,
    private bulkService: BulkServiceService,
    private userAccountFacade: UserAccountFacade
  ) {}

  ngOnInit(): void {
    this.quoteCheckoutService.receiveFilesCount.subscribe((count: number) => {
      this.filesCount = count
    })
    this.quoteCheckoutService.receiveCheckboxFlag.subscribe((flag) => {
      this.checkboxFlag = flag
    })
    this.orderGroup = this.fb.group({
      projectName: new FormControl(''),
      orderType: new FormControl(null, Validators.required),
    })

    //this.userDetails$ = this.getCustomerData();

    this.translate
      .translate('quoteCheckout.quoteCart')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadCrumbs([
          {
            label: res,
            link: '/quote/cart',
          },
        ])
      )

    this.translate
      .translate('quoteCheckout.quoteCheckoutLabel')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )

    this.quoteDataService.recieveEndUserIndustry.subscribe((data) => {
      this.endUserIndustry = data
    })
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          return of(undefined)
        }
      })
    )

    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.isLoggedinUser = success
        this.userType = 'current'
      } else {
        this.userType = 'anonymous'
      }
    })

    this.quoteCheckoutIdGenrate = this.bulkService.quoteCheckoutId.subscribe(
      (quoteCheckoutId) => {
        if (quoteCheckoutId) {
          this.getCartData()
        }
      }
    )

    this.getOrderType()
    this.getCartData()

    this.quoteDataService.recieveBillToAddressValidation.subscribe(
      (valid: boolean) => {
        this.billToValidation = valid
      }
    )
    this.quoteDataService.recieveComplienceValidation.subscribe(
      (valid: boolean) => {
        this.complienceValidation = valid
      }
    )
    this.quoteDataService.recieveEndUserAddressValidation.subscribe(
      (valid: boolean) => {
        this.endUserValidation = valid
      }
    )
    this.quoteDataService.recieveDeliveryAddressValidation.subscribe(
      (valid: boolean) => {
        this.deliveryValidation = valid
      }
    )
    this.quoteDataService.recieveNotificationValidation.subscribe(
      (valid: boolean) => {
        this.notificationValidation = valid
      }
    )

    // this.userDetails$.subscribe((res) => {
    //   this.userSapBlocked = (res?.orgUnit?.sapBlocked == "true") ? true : false;
    // });
  }

  // getCustomerData() {
  //   const params = ['users', 'current', 'myprofile']
  //   const apiUrl = this.commonService.constructUrl(params)
  //   return this.commonService.getData(apiUrl)
  // }

  getEndUserIndustry(value) {
    const endUserIndustries = 'endUserIndustries'
    this.quoteCheckoutService
      .getEndUserIndustry(this.userType)
      .subscribe((data: any) => {
        this.endUserIndustries = data[endUserIndustries]
        for (const endUserIndustryObj of this.endUserIndustries) {
          if (value === endUserIndustryObj.value) {
            this.quoteService.retainEndUserIndustry.next(
              endUserIndustryObj.code
            )
            this.cartData.endUserIndustry = endUserIndustryObj.code
          }
        }
        if (this.cartData.endUserIndustry === undefined) {
          this.cartData.endUserIndustry = ''
        }
      })
  }

  convertEndUserIndustry(value) {
    return this.getEndUserIndustry(value)
  }

  getCartData() {
    if (this.userType === 'current') {
      this.cartId = sessionStorage.getItem('cartId-current')
      this.quoteService
        .getCart(this.cartId, this.userType)
        .pipe(take(1))
        .subscribe((success) => {
          this.cartId = success['code']
        })
      this.cartId = this.cartId
        ? this.cartId
        : sessionStorage.getItem('cartId-current')
      this.cartData$ = this.quoteCheckoutService.getUserAddressDetails(
        this.userType,
        this.cartId
      )
      this.cartData$.subscribe(
        (data: any) => {
          this.bulkService.quoteCheckoutId.next(false)
          this.cartLoaded = true
          this.cartData = data

          if (this.cartData?.entries.length == 0) {
            this.globalMessageService.add(
              { key: 'quoteCheckout.noEntriesFound' },
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
            this.router.navigate(['quote/cart'])
          }
          this.orderGroup.controls['projectName'].setValue(
            this.cartData?.customerProjectName || ''
          )
          this.quoteDataService.sendAttachments(this.cartData.attachments)
          this.orderGroup.controls['orderType'].setValue(
            this.cartData?.rfqType || null
          )

          if (this.cartData?.quoteCartType == QuoteStatus.EDIT) {
            this.orderGroup.controls['projectName'].disable()
            this.orderGroup.controls['orderType'].disable()
          }
          this.cartData.billToAddress =
            this.cartData.billToAddress || new BillToAddress()

          this.cartData.deliveryAddress =
            this.cartData.deliveryAddress || new DeliveryAddress()

          this.cartData.endUserAddress =
            this.cartData.endUserAddress || new EndUserAddress()

          this.convertEndUserIndustry(this.cartData.endUserIndustry)

          this.orderGroup?.controls['quoteAcknowledge']?.setValue(
            this.cartData?.notificationEmail || ''
          )

          this.cartData.warningFlagText = this.cartData.warningFlagText || ''
          this.productData = data.entries
          this.cartData.code = this.cartId
          this.cartData.attachments = this.cartData.attachments || null
          this.cartData.contactNumber = this.cartData?.contactNumber

          this.cartData.customerReviewCheck = this.cartData.customerReviewCheck

          this.cartData.hasRestrictedUse = this.cartData.hasRestrictedUse

          this.cartData.isNuclear = this.cartData.isNuclear
          if (!this.cartData?.legalEntity) {
            this.globalMessageService.add(
              { key: 'quoteCheckout.legalEntityNotPresent' },
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
            this.router.navigate(['quote/cart'])
          }
          this.cartData.legalEntity = this.cartData.legalEntity || null

          this.cartData.restrictedCountryCheck =
            this.cartData.restrictedCountryCheck

          this.cartData.sanctionCheck = this.cartData.sanctionCheck

          if (this.cartData?.entries !== undefined) {
            for (var i = 0; i < this.cartData?.entries.length; i++) {
              if (!this.cartData?.entries[i].isCatalogItem) {
                this.showPrice = false
              }
            }
          }
        },
        (error) => {}
      )
    }
    if (this.userType === 'anonymous') {
      this.cartId = sessionStorage.getItem('cartId-anonymous')
      this.cartId = this.cartId
        ? this.cartId
        : sessionStorage.getItem('cartId-anonymous')
      this.cartData$ = this.quoteService.getCart(this.cartId, this.userType)
      this.cartData$.subscribe(
        (data) => {
          this.cartLoaded = true
          this.cartData = data

          if (this.cartData?.entries.length == 0) {
            this.globalMessageService.add(
              { key: 'quoteCheckout.noEntriesFound' },
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
            this.router.navigate(['quote/cart'])
          }
          if (this.cartData?.billToAddress?.country?.name) {
            this.quoteDataService.setSoldCountry(
              this.cartData?.billToAddress?.country?.name
            )
          }

          this.quoteDataService.sendAttachments(this.cartData.attachments)
          this.convertEndUserIndustry(this.cartData.endUserIndustry)
          this.productData = data.entries
          this.cartData.code = this.cartId
          this.cartData.deliveryAddress =
            this.cartData.deliveryAddress || new DeliveryAddress()
          this.cartData.billToAddress =
            this.cartData.billToAddress || new BillToAddress()
          this.cartData.contactNumber = this.cartData?.contactNumber
          this.cartData.customerProjectName =
            this.cartData.customerProjectName || ''
          this.cartData.customerReviewCheck = this.cartData.customerReviewCheck
          this.cartData.endUserAddress =
            this.cartData.endUserAddress || new EndUserAddress()
          this.cartData.hasRestrictedUse = this.cartData.hasRestrictedUse
          this.cartData.attachments = this.cartData.attachments || null
          this.cartData.isNuclear = this.cartData.isNuclear
          this.cartData.legalEntity = this.cartData.legalEntity || null
          this.cartData.restrictedCountryCheck =
            this.cartData.restrictedCountryCheck
          this.cartData.notificationEmail =
            this.cartData.notificationEmail || ''
          this.cartData.warningFlagText = this.cartData.warningFlagText || ''
          this.cartData.sanctionCheck = this.cartData.sanctionCheck
          this.cartData.rfqType = this.cartData.rfqType || OrderType.RESALE

          if (
            this.cartData?.cartOrderType?.code !== undefined &&
            this.cartData?.cartOrderType?.code !== null &&
            this.cartData?.cartOrderType?.code !== ''
          ) {
            this.orderGroup.controls['orderType'].setValue(
              this.cartData?.cartOrderType?.code
            )
          }
          if (
            this.cartData?.customerProjectName !== undefined &&
            this.cartData?.customerProjectName !== null &&
            this.cartData?.customerProjectName !== ''
          ) {
            this.orderGroup.controls['projectName'].setValue(
              this.cartData?.customerProjectName
            )
          }

          if (this.cartData?.entries !== undefined) {
            for (var i = 0; i < this.cartData?.entries.length; i++) {
              if (!this.cartData?.entries[i].isCatalogItem) {
                this.showPrice = false
              }
            }
          }
        },
        (error) => {}
      )
    }
  }
  ngOnDestroy() {
    if (this.quoteCheckoutIdGenrate) {
      this.quoteCheckoutIdGenrate.unsubscribe()
    }
  }
  setRFQtype(code) {
    this.rfqTypes.forEach((element) => {
      if (element.code === code) {
        return element.name
      }
    })
  }
  getOrderType() {
    this.orderTypeData$ = this.quoteCheckoutService.getOrderType(this.userType)
    this.orderTypeData$.subscribe((order: any) => {
      this.rfqTypes = order['orderType']
    })
  }

  cartUpdate(event) {
    this.cartData = event
    this.cartData.attachments =
      this.quoteDataService.attachmentSource.getValue()
    for (let endUserIndustryObj of this.endUserIndustries) {
      if (this.cartData?.endUserIndustry === endUserIndustryObj?.value) {
        this.cartData.endUserIndustry = endUserIndustryObj?.code
      }
    }
    if (this.cartData.warningFlagText == undefined) {
      this.cartData.warningFlagText = ''
    }
    if (
      this.cartData?.sanctionCheck === 'true' ||
      this.cartData?.sanctionCheck === true ||
      (this.cartData?.warningFlags === 'true' &&
        this.cartData.warningFlagText == '') ||
      (this.cartData?.warningFlags === true &&
        this.cartData.warningFlagText == '')
    ) {
      this.isDisabled = true //disabled
      // this.cd.detectChanges();
    } else {
      this.isDisabled = false // enabled
      // this.cd.detectChanges();
    }
  }
  checkoutBtnDisable() {
    if (
      this.filesCount >
        (this.quoteDataService.attachmentSource.getValue()?.length || 0) ||
      ((this.cartData?.governmentParties === 'true' ||
        this.cartData?.governmentParties === true ||
        this.cartData?.restrictedPartList === 'true' ||
        this.cartData?.restrictedPartList === true) &&
        this.checkboxFlag === false)
    ) {
      return true
    } else {
      return false
      // if(this.userSapBlocked){
      //   return true
      // } else{
      //   return false
      // }
    }
  }
  viewQuoteReview() {
    this.router.navigate(['quote/review'])
  }
  getNotificationEmail(event) {
    this.notificationEmail = event
  }
  getContactNumber(event) {
    this.contactNumber = event
  }
  scrollToError(): void {
    const firstElementWithError = document.querySelector(
      '.ng-invalid[formControlName]'
    )
    this.scrollTo(firstElementWithError)
  }
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      el.parentElement.focus()
    }
  }
  onQuoteReview() {
    this.quoteCheckoutService.checkSubmission.next(true)
    this.isSubmitted = true
    this.validationGroup = 'bill-to'
    this.cartData.rfqType = this.orderGroup.value.orderType
    this.cartData.customerProjectName = this.orderGroup.value.projectName
    if (this.orderGroup.controls['orderType'].invalid) {
      this.scrollToError()
      return
    }

    if (
      !this.cartData?.endUserIndustry ||
      this.cartData?.endUserIndustry == 'Select' ||
      this.cartData?.legalEntity == 'Select' ||
      !this.cartData?.legalEntity
    ) {
      return
    }
    if (
      this.cartData?.billToAddress?.country?.isocode == 'RU' ||
      this.cartData?.deliveryAddress?.country?.isocode == 'RU' ||
      this.cartData?.endUserAddress?.country?.isocode == 'RU'
    ) {
      const componentdata = {}

      const warningDialog = this.launchDialogService.openDialog(
        VS_LAUNCH_CALLER.WARNING_DIALOG,
        undefined,
        undefined,
        componentdata
      )
      if (warningDialog) {
        warningDialog.pipe(take(1)).subscribe((value) => {})
        this.launchDialogService.dialogClose.subscribe((value) => {})
      }
      return
    }
    // if (this.cartData?.restrictedCountryCheck) {
    //   return;
    // }
    if (
      this.billToValidation &&
      this.deliveryValidation &&
      this.endUserValidation &&
      this.notificationValidation &&
      this.complienceValidation &&
      this.userType === 'anonymous'
    ) {
      this.quoteCheckoutService
        .postQuoteCheckout(this.userType, this.cartId, this.cartData)
        .subscribe(
          (data: any) => {
            this.isSubmitted = false
            this.router.navigate(['quote/review'])
          },
          (error) => {
            this.globalMessageService.add(
              { key: 'quoteCheckout.errorOccuredPerformingAction' },
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
        )
    }

    if (
      this.userType === 'current' &&
      this.cartData?.billToAddress != null &&
      this.cartData?.deliveryAddress != null &&
      this.cartData?.endUserAddress != null &&
      this.cartData?.notificationEmail != null &&
      this.cartData?.notificationEmail !== '' &&
      this.cartData?.endUserIndustry !== '' &&
      this.complienceValidation &&
      this.notificationValidation
    ) {
      if (
        this.cartData?.rfqType === '' ||
        this.cartData?.rfqType === 'Select' ||
        !this.cartData?.rfqType
      ) {
        this.quoteDataService.sendBillToAddressValidation(true)
        this.quoteDataService.sendShipToAddressValidation(true)
        this.quoteDataService.sendEndUserAddressValidation(true)
        return
      }
      this.quoteCheckoutService
        .postQuoteCheckout(this.userType, this.cartId, this.cartData)
        .subscribe(
          (data: any) => {
            this.isSubmitted = false
            this.router.navigate(['quote/review'])
          },
          (error) => {
            this.globalMessageService.add(
              { key: 'quoteCheckout.errorOccuredPerformingAction' },
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
        )
    }
  }
  updateFile(event) {
    this.attachmentFiles = event
    this.uploadFiles()
  }
  uploadFiles() {
    this.spinnerOverlayService.show()
    this.isUploaded = false

    const formData = new FormData()
    this.attachmentFiles.forEach((element) => {
      formData.append('multipartFile', element)
    })
    this.quoteCheckoutService
      .uploadFiles(this.userType, this.cartId, formData)
      .subscribe(
        (success) => {
          this.isUploaded = true
          this.spinnerOverlayService.hide()
          this.quoteService
            .getCart(this.cartId, this.userType)
            .subscribe((success: any) => {
              this.cartData.attachments = success?.attachments
              this.quoteDataService.sendAttachments(success?.attachments)
              this.cd.detectChanges()
            })
        },
        (error) => {
          this.spinnerOverlayService.hide()
          this.isUploaded = true
        }
      )
  }

  checkForObsoleteProducts(cartData) {
    for (let entry of cartData.entries) {
      if (entry.product.obsoleteProductFlag) {
        return true
      }
    }
    return false
  }
  orderChange() {
    if (this.orderGroup.value.orderType === 'STOCK') {
      this.orderChanged = true
    } else {
      this.orderChanged = false
    }
  }
}
